 
 const Database = [

   {
  id: '7',
  button: 'View Website',
  name: 'Multimart Online Shop',
  description: `Multimart is a user-friendly e-commerce platform built with React and TailwindCSS, designed to make online shopping effortless. Browse products, add to cart, purchase securely, and leave reviews—all in one place. With door-to-door delivery, customers enjoy a seamless experience from click to delivery. Perfect for businesses looking to expand their reach online, Multimart helps you sell products like you do on Facebook, with easy uploads and daily updates`,
  img: 'iphone 14 acessories.jpeg',
  type: 'personal projects',
  link: 'https://www.mmshop.co.zw'
},

{
        id:'1',
        button:'CommingSoon',
        name:'OMINIVIEW',
        description:"Introducing OMINIVIEW! I've built a cutting-edge platform for telecommunications, solar energy, and electronics repair using React, Node.js, Express, and MongoDB.",
        img:'banner-img01.jpg',
        type:'coming soon',
        link:'https://ominiview.netlify.app'
    },

    {
        id:'2',
        button:'View Website',
        name:'ASTROMOBILES',
        description:'Astro mobiles are a brand of smartphones and mobile devices, primarily associated with V3 Mobile and Mobicel in certain regions. In Zimbabwe, Astro Mobile is actually an IT services company offering mobile phone services, telecommunications, and communication solutions.',
        img:'astro note 13 max.png',
        type:'personal projects',
        link:'https://astromobile.io'
    },

    {
        id:'3',
        button:'View Website ',
        name:'ZIMNEXT-SOLUTIONS',
        description:'Zimnext Solutions is a Zimbabwe-based company that offers innovative web development, digital marketing, and tech solutions tailored to local and international clients. They specialize in creating custom websites, mobile apps, and branding services. You can visit their website or contact them directly to learn more about their services.',
        img:'2 (1).png',
         type:'personal projects',
        link:'http://zimnextsolutions.co.zw/'
    },
   
    {
        id:'4',
        button:'View Website ',
        name:'BOOTSTRAP',
        description:'Highlighting my web development proficiency with HTML, CSS, and JavaScript, focusing on responsive layouts, clean code, and engaging user interactions.',
        img:'bootstrape.png',
        type:'personal projects',
        link:'https://danielmututa.github.io/Bootstrape-portfolio/'
    },
    {
        id:'5',
        button:'Download app',
        name:'PREPAID LOCK UP',
        description:'Still developing a secure Prepaid Lock Up feature for smartphones, designed to protect your device and data. The system will allow you to lock your device remotely using its IMEI, location, or phone number.',
        img:'phone screen set.png',
        type:'collaboration',
        
    },
    {
         id: '6',
        button: 'View Project',
        name: 'STRATEGIC BUILDERS',
        description: 'Showcasing the Strategic Builders company, a construction firm with over 10 years of experience in residential, commercial, and renovation projects. Includes staff management, project planning, and portfolio of completed works.',
        img: '1000089663.png',  // add an image for the project
        type: 'company-project',
         link: 'https://strategic-builders.co.zw' // replace wit
        
    },
];


export default Database